import { FC } from 'react';
import { AiOutlineFile, AiOutlineFileExcel, AiOutlineFileImage, AiOutlineFilePdf, AiOutlineFilePpt, AiOutlineFileWord, AiOutlineFileZip } from 'react-icons/ai';

export const DocumentIcon: FC<{fileName: string}> = ({ fileName }) => {
  const splitFileName = fileName.split('.');
  const extension = splitFileName[splitFileName.length - 1];
  const className = 'h-10 w-10 text-white';

  switch (extension) {
    case 'docx':
    case 'doc':
      return <AiOutlineFileWord className={className} />;
    case 'ppt':
      return <AiOutlineFilePpt className={className} />;
    case 'xlsx':
    case 'xlsm':
    case 'xlsb':
      return <AiOutlineFileExcel className={className} />;
    case 'pdf':
      return <AiOutlineFilePdf className={className} />;
    case 'gif':
    case 'png':
    case 'svg':
    case 'jpg':
      return <AiOutlineFileImage className={className} />;
    case 'zip':
      return <AiOutlineFileZip className={className} />;
    default:
      return <AiOutlineFile className={className} />;
  }
};